import type { DesignTemplateApi } from '@mathflat/domain/@entities/DesignTemplate/api'
import type { DesignTemplate } from '@mathflat/domain/@entities/DesignTemplate/dto.ts'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '@/utils/axios/maxios'

export const designTemplateApi = {
  getDesignTemplates(color: DesignTemplate['color']) {
    return maxios.get<DesignTemplateApi.Response.DesignTemplateSummary[]>(`/design-template`, {
      params: { color },
    })
  },

  getDesignTemplateById(id: DesignTemplate['id']) {
    return maxios.get<
      DefaultResponse<
        DesignTemplateApi.Response.SignatureWorkbookDesignTemplateWithRecommended['designTemplates'][number]
      >
    >(`/design-template/${id}`)
  },

  getFavoriteDesignTemplates() {
    return maxios.get<DesignTemplateApi.Response.DesignTemplateSummary[]>(
      `/design-template/favorite`,
    )
  },
  postFavoriteDesignTemplate(id: DesignTemplate['id']) {
    return maxios.post(`/design-template/${id}/favorite`)
  },
  deleteFavoriteDesignTemplate(id: DesignTemplate['id']) {
    return maxios.delete(`/design-template/${id}/favorite`)
  },
}
